import { Router } from './router';
import LinkToDebrief from 'ff/debrief/router/links/LinkToDebrief';
import LinkToHome from 'ff/debrief/router/links/LinkToHome';
import LinkToShared from 'ff/debrief/router/links/LinkToShared';
import LinkToSharedDebrief from 'ff/debrief/router/links/LinkToSharedDebrief';
import { RouteContext } from 'ff/debrief/router/RouteContext';
export {
    LinkToDebrief,
    LinkToHome,
    LinkToShared,
    LinkToSharedDebrief,
    RouteContext,
};
export default Router;
